module.exports = __webpack_public_path__ + "img/contact.d5daebec.jpg";